import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from './sub_components/toast';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as userService from '../services/userService'
import * as transectionService from '../services/transectionService'
import * as apiUserService from '../services/apiUserService'
import { BASE_IMAGE_PATH } from '../configs/api';
import { OPERATOR_ID } from '../configs/const';
import { casinoList, showBinary, showClubGames, showRebateBonus } from '../configs/casinoShowList';

class AddAffiliates extends Component {
    constructor(props) {
        super(props);
        this.textInput = React.createRef();
        this.eventHandleKey = this.eventHandleKey.bind(this);
        this.state = {
            id: null,
            usrid: "",
            password: "",
            account_type: "",
            client_remark: "",
            client_name: "",
            city: "",

        };
    }


    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', null)
    }
    handleKey(e) {
        if (e.keyCode === 13) {
            this.submitForm();
        }
    }
    eventHandleKey(e) {
        if (e.keyCode === 13) {
            this.textInput.focus();
        }
    }









    clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === undefined) {
                delete obj[propName];
            }
        }
        return obj
    }




    render() {
        return (
            <div className="bethubs">
                <Header history={this.props.history} />
                <div className="wrapper">
                    <div className="container-fluid container-padding-0">
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="main-box" style={!this.state.edit_loader ? { display: 'block' } : { display: 'none' }}>
                                    <h5 className="text-blue">Add/Edit Client Account</h5>
                                    <span></span>
                                    <div className="row supermaster mt-3">
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                            <fieldset>
                                                <legend>Affiliate Details:</legend>
                                                <div className="row">
                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                                        <div className="row">
                                                            <div className="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Name:</label>
                                                                    <input type="text" tabIndex="1" name="" className="form-control" placeholder="" id="" />
                                                                </div>
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">User Name:</label>
                                                                    <input type="text" tabIndex="2" name="" className="form-control" placeholder="" id="" />
                                                                </div>
                                                            </div>

                                                            <div className="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Email:</label>
                                                                    <input type="email" tabIndex="3" name="" className="form-control" placeholder="" id="" />
                                                                </div>
                                                            </div>

                                                            <div className="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Refrence Name:</label>
                                                                    <input type="text" tabIndex="4" name="" className="form-control" placeholder="" id="" />
                                                                </div>
                                                            </div>

                                                            <div className="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Whatsapp Number:</label>
                                                                    <input type="number" tabIndex="5" name="" className="form-control" placeholder="" id="" />
                                                                </div>
                                                            </div>

                                                            <div className="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Affiliate Code:</label>
                                                                    <input type="text" tabIndex="6" name="" className="form-control" placeholder="" id="" />
                                                                </div>
                                                            </div>

                                                            <div className="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Password:</label>
                                                                    <input type="number" tabIndex="7" name="" className="form-control" placeholder="" id="" />
                                                                </div>
                                                            </div>


                                                            <div className="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Website:</label>
                                                                    <input type="text" tabIndex="8" name="" className="form-control" placeholder="" id="" />
                                                                </div>
                                                            </div>

                                                            <div className="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Number:</label>
                                                                    <input type="number" tabIndex="9" name="" className="form-control" placeholder="" id="" />
                                                                </div>
                                                            </div>

                                                            <div className="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Referral Code:</label>
                                                                    <input type="text" tabIndex="10" name="" className="form-control" placeholder="" id="" />
                                                                </div>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>



                                    <button className="btn btn-blue accbtn float-right" tabIndex="">Create Affiliate</button>


                                </div>
                                {this.state.edit_loader &&
                                    <div className="main-box text-center d-flex align-items-center justify-content-center">
                                        <h3 className="text-dark">Fetching Data.............</h3>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                <Footer />
            </div >
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AddAffiliates);